import DynamicBreadcrumbsNavItem from "./DynamicBreadcrumbsNavItem";
import compose from "recompose/compose";
import withHandlers from "recompose/withHandlers";
import mapProps from "recompose/mapProps";

const enhance = compose(
  mapProps(({ character, ...props }) => {
    return {
      ...props,
      ...character,
    };
  }),
  withHandlers({
    onChange: (props) => () => {
      return props.onChangeOption(props.optionIndex, props.letter, props.id);
    },
  })
);

export default enhance(DynamicBreadcrumbsNavItem);
